const VALIDATION_MESSAGES = {
	"wireSize_oneOnly": "Please select only one option for wire size.",
	"material_oneOnly": "Please select only one option: copper or aluminium.",
	"doesFAUWork": "Please select only one option for FAU: yes or no.",
  "doesFAUWork_explanationMsg": "Please provide an explanation for FAU not working.",
  "refer_oneOption": "Please select only one option for refer size.",
  "thermostatInfo_oneOption": "Please select only one option for thermostat info.",
  "ductSystemType_oneOption": "Please select only one option for duct system type.",
  "ductSystemAsbestos_oneOption": "Please select only one option for duct system asbestos.",
  "ductSystemAsbestosType_oneOption": "Please select one option for asbestos if previous question is checked yes.",
  "housingType_oneOption": "Please select one option for housing type.", 
  "swampCooler_oneOption": "Please select only one option for swamp cooler yes/no"
} 

const useValidation = (control) => {
  const { getValues } = control;
	return {
    "wireSize_6": () => ({
      validate: () => {
        const conditions = ["wireSize_6", "wireSize_8", "wireSize_10", "wireSize_12"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['wireSize_oneOnly'];
      },
    }),
    "isCopper": () => ({
      validate: () => {
        const conditions = ["isCopper", "isAluminium"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['material_oneOnly'];
      },
    }),
    "doesFAUWork_yes": () => ({
      validate: () => {
        const conditions = ["doesFAUWork_yes", "doesFAUWork_no"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['doesFAUWork'];
      },
    }),
    "doesFAUWork_explanation": () => ({
      validate: (text) => {
        const doesFAUWork_explanation = getValues("doesFAUWork_no");
        return (doesFAUWork_explanation === !!text) || VALIDATION_MESSAGES['doesFAUWork_explanationMsg']
      },
    }),
    "refer_is34ths": () => ({
      validate: () => {
        const conditions = ["refer_is34ths", "refer_is58ths", "refer_is78ths", "refer_is1Inch"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['refer_oneOption'];
      },
    }),
    "thermostatInfo_wifi": () => ({
      validate: () => {
        const conditions = ["thermostatInfo_wifi", "thermostatInfo_nestTStat"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['thermostatInfo_oneOption'];
      },
    }),
    "ductSystemType_flexDuct": () => ({
      validate: () => {
        const conditions = ["ductSystemType_flexDuct", "ductSystemType_hardPipe", "ductSystemType_fiberGlass", "ductSystemType_cloth"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['ductSystemType_oneOption'];
      },
    }),
    "ductSystemAsbestos_yes": () => ({
      validate: () => {
        const conditions = ["ductSystemAsbestos_yes", "ductSystemAsbestos_no"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['ductSystemAsbestos_oneOption'];
      },
    }),
    // "ductSystemAsbestos_duct": () => ({
    //   validate: () => {
    //     const conditions = ["ductSystemAsbestos_duct", "ductSystemAsbestos_plenum"];
    //     const count = conditions.filter(condition => !!getValues(condition)).length;
    //     return (count === 1) || VALIDATION_MESSAGES['ductSystemAsbestosType_oneOption'];
    //   },
    // }),
    "housingType_single": () => ({
      validate: () => {
        const conditions = ["housingType_single", "housingType_2Story"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['housingType_oneOption'];
      },
    }),
    "ductSystemAsbestos_no": () => ({
      validate: () => {
        const ductSystemAsbestosYes = !!getValues("ductSystemAsbestos_yes");

        const options = [
          "ductSystemAsbestos_duct",
          "ductSystemAsbestos_plenum",
        ];

        const count = options.filter((field) => !!getValues(field)).length;

        if (!ductSystemAsbestosYes) return true;

        return count >= 1 || VALIDATION_MESSAGES["ductSystemAsbestosType_oneOption"];
      },
    }),
    "swampCooler_yes": () => ({
      validate: () => {
        const conditions = ["swampCooler_yes", "swampCooler_no"];
        const count = conditions.filter(condition => !!getValues(condition)).length;
        return (count === 1) || VALIDATION_MESSAGES['swampCooler_oneOption'];
      },
    }),
	}
};

export default useValidation;